import JSBI from 'jsbi';

export const round = (decimals: number, minAmountOut: string) => {
  return Number.isInteger(Number(minAmountOut))
    ? minAmountOut
    : Math.ceil(
        Math.round(Number(minAmountOut) * Math.pow(10, decimals)) /
          Math.pow(10, decimals)
      ).toString();
};

export const decimalsExponentiateBase = JSBI.BigInt(10);

export const addDecimals = (number: JSBI, decimals: JSBI | number) => {
  const decimalsJSBI =
    decimals instanceof JSBI ? decimals : JSBI.BigInt(decimals);

  const multiplier = JSBI.exponentiate(decimalsExponentiateBase, decimalsJSBI);

  return JSBI.multiply(number, multiplier);
};

export const removeDecimals = (number: JSBI, decimals: JSBI | number) => {
  const decimalsJSBI =
    decimals instanceof JSBI ? decimals : JSBI.BigInt(decimals);

  const multiplier = JSBI.exponentiate(decimalsExponentiateBase, decimalsJSBI);

  return JSBI.divide(number, multiplier);
};

export const changeDecimals = (
  number: JSBI,
  fromDecimals: number,
  toDecimals: number
) => {
  const numbweWithNewDecimals = removeDecimals(
    addDecimals(number, toDecimals),
    fromDecimals
  );

  return numbweWithNewDecimals;
};
